export const ASSISTANT_RECORD_TYPES = [
  "order",
  "quote",
  "lead",
  "company",
  "contact",
  "product",
  "ticket",
  "user",
] as const;

export type AssistantRecordType = (typeof ASSISTANT_RECORD_TYPES)[number];

export const ADMIN_RECORD_ROUTE_SEGMENTS: Readonly<Record<AssistantRecordType, string>> = {
  order: "orders",
  quote: "quotes",
  lead: "leads",
  company: "companies",
  contact: "contacts",
  product: "products",
  ticket: "support",
  user: "users",
};

export const ASSISTANT_RECORD_TYPE_LABELS: Readonly<Record<AssistantRecordType, string>> = {
  order: "Order",
  quote: "Quote",
  lead: "Lead",
  company: "Company",
  contact: "Contact",
  product: "Listing",
  ticket: "Ticket",
  user: "User",
};

export const MAX_ATTACHED_RECORDS = 5;
export const MAX_ATTACHMENT_LABEL_CHARS = 120;
export const MAX_SCREENSHOT_BYTES = 5 * 1024 * 1024;
export const SCREENSHOT_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
